// covered-by: frontends/carrie/src/components/__tests__/ReviewInterventionBanner.test.tsx
import { WarningCircle } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

import { ComposerActionBanner } from "./ComposerActionBanner";

export type ReviewInterventionBannerProps = {
  /** What the review is waiting on, in the reader's language. */
  message: string;
  actionLabel: string;
  onAction: () => void;
  onDismiss: () => void;
  busy?: boolean;
};

/** A review that cannot continue until the user does something. */
export function ReviewInterventionBanner({
  message,
  actionLabel,
  onAction,
  onDismiss,
  busy,
}: ReviewInterventionBannerProps) {
  const { t } = useTranslation("ui");
  return (
    <ComposerActionBanner
      testId="review-intervention-banner"
      primaryTestId="review-intervention-banner-action"
      ariaLabel={t("askV2.transport.reviewInterventionBannerAriaLabel")}
      icon={
        <WarningCircle
          size={16}
          weight="fill"
          className="mt-0.5 shrink-0 text-puntt-accent-11"
          aria-hidden="true"
        />
      }
      message={message}
      primaryLabel={actionLabel}
      onPrimary={onAction}
      dismissLabel={t("askV2.transport.reviewInterventionBannerDismiss")}
      onDismiss={onDismiss}
      closeAriaLabel={t(
        "askV2.transport.reviewInterventionBannerCloseAriaLabel",
      )}
      busy={busy}
    />
  );
}
